export const security = {
  'if-you-donot-have-patranomic': 'Эгер атасынын аты жок болсо, сызыкча коюңуз',
  citizenship: 'Жарандыгы',
  'email-results': 'Текшерүүнүн жыйынтыгы боюнча сиздин <strong>{userEmail}</strong> почтаңызга кат жөнөтүлөт',
  'store-manager': 'Дүкөндүн директору',
  'security-questionnaire': 'Ички анкета',
  'acceptable-formats': 'Жол берилген форматтар — .jpeg, .jpg, .png, .pdf',
  'download-file-before-sending': 'Жөнөтүүдөн мурун файл(дарды) жүктөңүз',
  'field-too-long': 'Максималдуу узундугу — 255 символ',
};
